import { createLogPrefix, type LogTarget } from '@amazon/vinyl-util'
import { getPlaybackEnv } from './playbackEnvRef'

export interface PlaybackContext {
    readonly target: LogTarget
    /** Reports through the installed env's `errors`, read at call time so a module can build its context on import. */
    readonly errorHandler: (error: unknown) => void
}

export function ctx(name: string): PlaybackContext {
    const target: LogTarget = { logPrefix: createLogPrefix(name) }
    return {
        target,
        errorHandler: (error) => getPlaybackEnv().errors.handleError(target, error),
    }
}
